import React from 'react';
import Assignee from './Assignee';
import Captions from './Captions';
import AudioDescriptions from './AudioDescriptions';
import TabContentWrapper from '../TabContentWrapper';
import {IWorkerState} from '../../../model/workerState';
import config from '../../../service/config';

const AccessibilityTab: React.FC<IAccessibilityProps> = ({captionsWorkingState}) => (
   <TabContentWrapper showSpinner={false} showError={false}>
      {!config.featureSwitches.DisableCaptioningAssigneeOption && <Assignee />}
      <Captions isWorking={captionsWorkingState.isWorking} hasError={captionsWorkingState.hasError}/>
      <AudioDescriptions />
   </TabContentWrapper>
);

export default AccessibilityTab;

export interface IAccessibilityProps {
   captionsWorkingState: IWorkerState;
}